module.exports = __webpack_public_path__ + "static/media/back.62435201.svg";